import React, { useState, useEffect, useRef } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Styles/CheckboxList.css';
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../BasicElements/BackModal';
import ConfirmModal from '../../BasicElements/ConfirmModal';
import { useCookies } from "react-cookie";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const EntitlementUpdate = (props) => {
  //#region React Hooks
	const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
	const [hasChanges, setHasChanges] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [isActive, setIsActive] = useState(true);
	const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

	useEffect(() => {
			if (props.editData !== null) {
				setEditData({
					ENTITLEMENT_LEAVE_ID: props.editData.ENTITLEMENT_LEAVE_ID === null ? "" : props.editData.ENTITLEMENT_LEAVE_ID,
					CATEGORY_TYPE_NAME: props.editData.CATEGORY_TYPE_NAME === null ? "" : props.editData.CATEGORY_TYPE_NAME,
					WORK_TYPE: props.editData.WORK_TYPE === null ? "" : props.editData.WORK_TYPE,
					YEAR_FROM: props.editData.YEAR_FROM === null ? "" : props.editData.YEAR_FROM,
					YEAR_TO: props.editData.YEAR_TO === null ? "" : props.editData.YEAR_TO,
					DAYS: props.editData.DAYS === null ? "" : props.editData.DAYS,
				})
			}
		}, [props.editData]);
  //#endregion

	//#region Save Edit
  function saveEditEntitlement() {
    let functionName = "";
    try {
      functionName = saveEditEntitlement.name;
      setLoading(true, "Updating entitlement, Please wait....");
      const data = {
        ENTITLEMENT_LEAVE_ID: editData.ENTITLEMENT_LEAVE_ID,
        CATEGORY_TYPE_NAME: editData.CATEGORY_TYPE_NAME,
        EMP_WORKTYPE: editData.WORK_TYPE,
        YEAR_FROM: editData.YEAR_FROM,
				YEAR_TO: editData.YEAR_TO,
				DAYS: editData.DAYS,
				ACTIVE_FLAG: isActive ? "Y" : "N", 
        UPDATE_ID: userId,
        FROM_SOURCE: {SOURCE: "WEB", MODULE_ID: props.module },
      };

      http
        .post("api/entitlement/EntitlementUpdate", data, { timeout: 10000})
        .then((response) => {
					toast.success("Entitlement is successfully Updated.");
					props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to update entitlement. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Failed to update entitlement. Please try again.....(receive)");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
	};

	//#region Event handle
	const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
    if (Object.values(inputError).filter(v => v !== "").length === 0){
    	setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    saveEditEntitlement();
    setShowConfirmModal(false); // Hide confirm modal
		hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal on cancel
  };
	//#endregion

  return (
    <>
    <Modal show={props.showHide} onHide={hideModal} centered size="mg">
			<Modal.Header>
				<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
					<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit</Modal.Title>
				</div>
			</Modal.Header>

			<Modal.Body>
				<Comp.Input
					id="EMP_WORKTWORK_TYPEYPE"
					label="Work Type"
					name="Work Type"
					type="text"
					className="form-control"
					value={editData.WORK_TYPE}
					readOnly
				/>

				<Comp.Input
					id="YEAR_FROM"
					label="Year From*"
					name="Year From"
					type="text"
					className="form-control"
					errorMessage={inputError.YEAR_FROM}
					value={editData.YEAR_FROM}
					onChange={inputRequiredHandler}
				/>

				<Comp.Input
					id="YEAR_TO"
					label="Year To*"
					name="Year To"
					type="text"
					className="form-control"
					errorMessage={inputError.YEAR_TO}
					value={editData.YEAR_TO}
					onChange={inputRequiredHandler}
				/>

				<Comp.Input
					id="DAYS"
					label="Days*"
					name="Days"
					type="text"
					className="form-control"
					errorMessage={inputError.DAYS}
					value={editData.DAYS}
					onChange={inputRequiredHandler}
				/>
			</Modal.Body>

			<Modal.Footer>
        <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
						
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

			{/* Confirmation Modal */}
			<BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
				prop="Confirm Navigation"
			>
				Are you sure you want to go back? Your changes may be lost.
			</BackModal>

			<ConfirmModal
				show={showConfirmModal}
				onHide={handleConfirmModalClose}
				onConfirm={handleConfirmModal}
				prop="Confirm to save"
			>
				Are you sure you want to update entitlement?
			</ConfirmModal>
				
			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
			<Comp.AlertPopup />
			</>
    );
};

export default EntitlementUpdate;
